import styled from 'styled-components'

export const AvatarWrapper = styled.div`
  display: flex;
  align-items: center;
  padding-bottom: 2rem;
  margin-bottom: 1rem;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);

  h4 {
    font-size: 16px;
  }

  .ant-avatar {
    margin-right: .5rem;
  }
`
export const InfoWrapper = styled.div``

export const TitleInfo = styled.h4`
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 16px;
`
